import React, { useState } from 'react'
import { array, func, bool, string } from 'prop-types'
import styled from 'styled-components'
import ScrollAnimation from 'react-animate-on-scroll'

import Flavour from './Flavour'
import Featured from './Featured'

const Container = styled.div`
  position: relative;
  background-color: #14191d;
  height: 100%;
`

const Inner = styled.div`
  display: grid;
  grid-template-columns: repeat(5, 1fr);
  grid-template-rows: repeat(3, 1fr);
  grid-column-gap: 0;
  grid-row-gap: 0;
  height: 100%;
`

const FeaturedWrap = styled.div`
  grid-area: 1 / 4 / 5 / 6;
`

const Item = styled.div`
  position: static;
  width: 100%;
  height: 100%;
`

const FlavourShowcase = ({ flavours, handleCtaClick, ctaLabel, hideCurrentFlavour, isEpod }) => {
  const [selectedSlug, setSelectedSlug] = useState(isEpod ? flavours[1].slug : flavours[0].slug)

  return (
    <Container className="u-hide-medium-down">
      <Inner>
        {flavours
          .filter(f => f.visible)
          .map((flavour, i) => (
            <Item key={`item-${i}`} as={ScrollAnimation} animateIn="fadeInUp" offset={0} delay={i * 100} animateOnce>
              <Flavour
                key={i}
                name={flavour.name}
                price={flavour.price}
                slug={flavour.slug}
                background={flavour.background}
                onClick={() => {
                  setSelectedSlug(flavour.slug)
                  if (isEpod) hideCurrentFlavour(flavour.slug)
                }}
              />
            </Item>
          ))}
        <FeaturedWrap>
          <Featured
            name={flavours.find(f => f.slug === selectedSlug).prettyName}
            price={flavours.find(f => f.slug === selectedSlug).price}
            slug={flavours.find(f => f.slug === selectedSlug).slug}
            isOnlineOnly={flavours.find(f => f.slug === selectedSlug).isOnlineOnly}
            link={flavours.find(f => f.slug === selectedSlug).link}
            background={flavours.find(f => f.slug === selectedSlug).background}
            description={flavours.find(f => f.slug === selectedSlug).description}
            isNew={flavours.find(f => f.slug === selectedSlug).isNew}
            ctaLabel={ctaLabel}
            handleCtaClick={handleCtaClick}
          />
        </FeaturedWrap>
      </Inner>
    </Container>
  )
}

FlavourShowcase.propTypes = {
  handleCtaClick: func.isRequired,
  flavours: array.isRequired,
  ctaLabel: string.isRequired,
  isEpod: bool,
  hideCurrentFlavour: func
}

export default FlavourShowcase
